import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Typography, Paper, Avatar, Button, Chip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import PublicIcon from '@mui/icons-material/Public';
import PinDropIcon from '@mui/icons-material/PinDrop';
import BaseUrl from '../Api/baseurl';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import axios from 'axios';

const UserProfile = ({ setIsLoggedIn }) => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState({
    username: '',
    first_name: '',
    last_name: '',
    email: '',
    phone_no: '',
    address: '',
    city: '',
    state: '',
    country: '',
    zipcode: '',
    profile_picture: '',
    gender: '',
  });

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    const token = Cookies.get('token');
    if (!token) {
      Swal.fire({
        icon: 'warning',
        title: 'Please login to continue.',
      });
      navigate('/user/login');
      return;
    }

    const apiUrl = `${BaseUrl}/userdetails`;
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      });
      setUserData(response.data);
    } catch (error) {
      console.error('Error fetching user data:', error);
      if (error.response?.status === 401) {
        Swal.fire({
          icon: 'warning',
          title: 'Session expired. Please login again.',
        });
        Cookies.remove('token');
        Cookies.remove('is_user');
        Cookies.remove('username');
        setIsLoggedIn(false);
        navigate('/user/login');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to load profile data.',
        });
      }
    }
  };

  const [pastBookings] = useState([
    { id: 1, date: '2023-03-15', service: 'Haircut & Styling', status: 'Completed' },
    { id: 2, date: '2023-04-20', service: 'Beard Trim', status: 'Completed' },
    { id: 3, date: '2023-05-10', service: 'Hair Color', status: 'Upcoming' },
  ]);

  return (
    <div className="container mx-auto p-4 sm:p-6 w-full">
      {/* Profile Section */}
      <Paper elevation={3} className="p-8 mb-8 rounded-xl bg-white w-full">
        <div className="flex justify-between items-center mb-6">
          <Typography variant="h4" className="font-bold" style={{ color: '#212529' }}>
            My Profile
          </Typography>
          <Button
            variant="contained"
            style={{ backgroundColor: '#BF9455', color: '#FFFFFF' }}
            startIcon={<EditIcon />}
            component={Link}
            to="/user/myprofile/edit"
            className="hover:!bg-[#A07B3F]"
          >
            Edit Profile
          </Button>
        </div>

        <div className="flex flex-col md:flex-row gap-6">
          {/* Profile Picture */}
          <div className="flex flex-col items-center">
            <Avatar
              src={userData.profile_picture}
              sx={{ width: 160, height: 160 }}
              className="border-4 border-[#BF9455] shadow-md"
            />
            <Typography
              className="mt-4 font-semibold"
              style={{ color: '#212529' }}
            >
              {userData.first_name} {userData.last_name}
            </Typography>

            <Typography
              className="font-semibold flex items-center gap-1.5"
              style={{ color: '#212529' }}
            >
              Username:
              <p className='text-gray-500'>
              {userData.username}
              </p>
            </Typography>
          </div>

          {/* Profile Details */}
          <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-center">
              <PersonIcon style={{ color: '#BF9455' }} className="mr-3" />
              <div>
                <Typography variant="subtitle2" style={{ color: '#212529' }}>
                  First Name
                </Typography>
                <Typography variant="body1" style={{ color: '#212529' }}>
                  {userData.first_name || 'Not provided'}
                </Typography>
              </div>
            </div>
            <div className="flex items-center">
              <PersonIcon style={{ color: '#BF9455' }} className="mr-3" />
              <div>
                <Typography variant="subtitle2" style={{ color: '#212529' }}>
                  Last Name
                </Typography>
                <Typography variant="body1" style={{ color: '#212529' }}>
                  {userData.last_name || 'Not provided'}
                </Typography>
              </div>
            </div>
            <div className="flex items-center">
              <EmailIcon style={{ color: '#BF9455' }} className="mr-3" />
              <div>
                <Typography variant="subtitle2" style={{ color: '#212529' }}>
                  Email
                </Typography>
                <Typography variant="body1" style={{ color: '#212529' }}>
                  {userData.email || 'Not provided'}
                </Typography>
              </div>
            </div>
            <div className="flex items-center">
              <PhoneIcon style={{ color: '#BF9455' }} className="mr-3" />
              <div>
                <Typography variant="subtitle2" style={{ color: '#212529' }}>
                  Phone Number
                </Typography>
                <Typography variant="body1" style={{ color: '#212529' }}>
                  {userData.phone_no || 'Not provided'}
                </Typography>
              </div>
            </div>
            <div className="flex items-center">
              <HomeIcon style={{ color: '#BF9455' }} className="mr-3" />
              <div>
                <Typography variant="subtitle2" style={{ color: '#212529' }}>
                  Address
                </Typography>
                <Typography variant="body1" style={{ color: '#212529' }}>
                  {userData.address || 'Not provided'}
                </Typography>
              </div>
            </div>
            <div className="flex items-center">
              <LocationCityIcon style={{ color: '#BF9455' }} className="mr-3" />
              <div>
                <Typography variant="subtitle2" style={{ color: '#212529' }}>
                  City
                </Typography>
                <Typography variant="body1" style={{ color: '#212529' }}>
                  {userData.city || 'Not provided'}
                </Typography>
              </div>
            </div>
            <div className="flex items-center">
              <LocationCityIcon style={{ color: '#BF9455' }} className="mr-3" />
              <div>
                <Typography variant="subtitle2" style={{ color: '#212529' }}>
                  State
                </Typography>
                <Typography variant="body1" style={{ color: '#212529' }}>
                  {userData.state || 'Not provided'}
                </Typography>
              </div>
            </div>
            <div className="flex items-center">
              <PublicIcon style={{ color: '#BF9455' }} className="mr-3" />
              <div>
                <Typography variant="subtitle2" style={{ color: '#212529' }}>
                  Country
                </Typography>
                <Typography variant="body1" style={{ color: '#212529' }}>
                  {userData.country || 'Not provided'}
                </Typography>
              </div>
            </div>
            <div className="flex items-center">
              <PinDropIcon style={{ color: '#BF9455' }} className="mr-3" />
              <div>
                <Typography variant="subtitle2" style={{ color: '#212529' }}>
                  Zipcode
                </Typography>
                <Typography variant="body1" style={{ color: '#212529' }}>
                  {userData.zipcode || 'Not provided'}
                </Typography>
              </div>
            </div>
            <div className="flex items-center">
              <PersonIcon style={{ color: '#BF9455' }} className="mr-3" />
              <div>
                <Typography variant="subtitle2" style={{ color: '#212529' }}>
                  Gender
                </Typography>
                <Typography variant="body1" style={{ color: '#212529' }} className='capitalize'>
                  {userData.gender || 'Not provided'}
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </Paper>

      {/* Past Bookings Section */}
      <Paper elevation={3} className="p-8 rounded-xl bg-white w-full">
        <Typography
          variant="h5"
          className="font-bold mb-6"
          style={{ color: '#212529' }}
        >
          Past Bookings
        </Typography>
        {pastBookings.length === 0 ? (
          <Typography
            variant="body1"
            className="text-center py-4"
            style={{ color: '#212529' }}
          >
            No past bookings found
          </Typography>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full table-auto">
              <thead>
                <tr className="bg-gray-100">
                  <th
                    className="px-4 py-2 text-left"
                    style={{ color: '#212529' }}
                  >
                    Service
                  </th>
                  <th
                    className="px-4 py-2 text-left"
                    style={{ color: '#212529' }}
                  >
                    Date
                  </th>
                  <th
                    className="px-4 py-2 text-left"
                    style={{ color: '#212529' }}
                  >
                    Status
                  </th>
                  <th
                    className="px-4 py-2 text-left"
                    style={{ color: '#212529' }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {pastBookings.map((booking) => (
                  <tr
                    key={booking.id}
                    className="border-b hover:bg-gray-50"
                    style={{ borderColor: '#212529' }}
                  >
                    <td className="px-4 py-3" style={{ color: '#212529' }}>
                      {booking.service}
                    </td>
                    <td className="px-4 py-3" style={{ color: '#212529' }}>
                      {booking.date}
                    </td>
                    <td className="px-4 py-3">
                      <Chip
                        label={booking.status}
                        color={booking.status === 'Completed' ? 'success' : 'warning'}
                        size="small"
                      />
                    </td>
                    <td className="px-4 py-3">
                      <Button
                        variant="outlined"
                        style={{
                          borderColor: '#212529',
                          color: '#212529',
                        }}
                        size="small"
                        className="hover:bg-[#BF9455] hover:!text-white"
                      >
                        View Details
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Paper>
    </div>
  );
};

export default UserProfile;